module.exports = __webpack_public_path__ + "img/logo.a290ce5a.png";